<template>
  <v-main class="ssr-fix-main">
    <slot />
  </v-main>
</template>
